<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/materiales`;
const apiUrlTraduccion = `${process.env.VUE_APP_API_URL}/api/traduccion`;
const apiUrlEcommerce = process.env.VUE_APP_API_URL;
//const token = utilsService.getToken();
let lastLogEndpointVariant = null; // 'logs' | 'log' | 'none'
const pagingGuards = Object.create(null); 

function buildArchivoAdjuntoFormData(sourceFormData, { idFamilia, idItem }) {
  const idUsuarioCreacion = Number(localStorage.getItem('user-id')) || 1;
  const files = (sourceFormData && typeof sourceFormData.getAll === 'function')
    ? sourceFormData.getAll('files')
    : [];

  if (!idItem || !files.length) {
    throw new Error('Parámetros inválidos para subir archivos adjuntos.');
  }

  const formData = new FormData();
  formData.append('IdFamilia', Number(idFamilia));
  formData.append('IdTipoArchivo', 2);
  formData.append('IdItem', Number(idItem));
  formData.append('Observacion', '');
  formData.append('IdUsuarioCreacion', idUsuarioCreacion);

  files.forEach((f) => formData.append('files', f));

  return formData;
}

async function resolveLastLogEndpoint(idEmpresa) {
  if (lastLogEndpointVariant) return lastLogEndpointVariant;

  // 1) intenta plural
  try {
    await axios.get(`${apiUrl}/get-last-file-logs`, {
      params: { idEmpresa },
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    lastLogEndpointVariant = 'logs';
    return 'logs';
  } catch (e1) {
    const s1 = e1 && e1.response && e1.response.status ? e1.response.status : 0;
    if (s1 !== 404 && s1 !== 500) console.debug('resolve logs err', s1);
  }

  // 2) fallback singular
  try {
    await axios.get(`${apiUrl}/get-last-file-log`, {
      params: { idEmpresa },
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    lastLogEndpointVariant = 'log';
    return 'log';
  } catch (e2) {
    const s2 = e2 && e2.response && e2.response.status ? e2.response.status : 0;
    if (s2 !== 404 && s2 !== 500) console.debug('resolve log err', s2);
  }

  lastLogEndpointVariant = 'none';
  return 'none';
}
const materialService = {
 // --- CLUSTER: Detalle por criterio/cluster ---
// --- EC0MMERCE: Detalle por criterio/cluster ---
async getClustersDetalle(token, idCriterio, numeroCluster, idCluster, lang = 'es') {
//console.log('[getClustersDetalle] parámetros recibidos:', { token, idCriterio, numeroCluster, idCluster });

  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL || '';
  const t  = encodeURIComponent(String(token || '').trim());
  const ic = Number(idCriterio || 0);
  const nc = encodeURIComponent(String(numeroCluster || '').trim());
  const icl = Number(idCluster || 0);

  
  if (!t || !ic || !nc || !icl) {
    console.warn('[getClustersDetalle] parámetros inválidos', { t, ic, nc, icl });
    throw new Error('Parámetros inválidos');
  }

  const headers = {
    'Authorization': 'Bearer ' + utilsService.getToken(),
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  const url = `${base}/api/ecommerce/getClustersDetalle/${t}/${ic}/${nc}/${icl}`;

  console.log('[getClustersDetalle] GET:', url);

  try {
    const resp = await axios.get(url, { headers, params: { lang } });
    const data = resp && resp.data ? resp.data : [];

    console.log('[getClustersDetalle] items recibidos:', data.length);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('[getClustersDetalle] error:', e);
    throw e;
  }
},
async subirFotosCluster(formData) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const detalleId = Number(formData.get('detalleId'));
  const payload = buildArchivoAdjuntoFormData(formData, {
    idFamilia: 2,
    idItem: detalleId
  });
  const url = `${base}/api/ArchivoAdjunto/crear`;
  const resp = await axios.post(url, payload, { headers });
  return resp.data;
},

async getFotosCluster(token, detalleId) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/ecommerce/getFotosCluster/${token}/${detalleId}`;
  const resp = await axios.get(url, { headers });
  const data = Array.isArray(resp.data) ? resp.data : [];
  return data.map(x => ({
    ...x,
    esPortada: Boolean(x.esPortada != null ? x.esPortada : x.EsPortada)
  }));
},
async eliminarFotoCluster(idFoto) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };

  return axios.delete(`${base}/api/ecommerce/eliminarFotoCluster/${idFoto}`, { headers });
},

// --- VIDEOS DE ITEM ---
async getVideosItem(token, detalleId) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/ecommerce/getVideosItem/${token}/${detalleId}`;
  const resp = await axios.get(url, { headers });
  const data = Array.isArray(resp.data) ? resp.data : [];
  return data.map(x => ({
    ...x,
    esPortada: Boolean(x.esPortada != null ? x.esPortada : x.EsPortada)
  }));
},

async agregarVideoItem(data) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken(),
    "Content-Type": "application/json"
  };
  const url = `${base}/api/ecommerce/agregarVideoItem`;
  const resp = await axios.post(url, data, { headers });
  return resp.data;
},

async eliminarVideoItem(idVideo) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/ecommerce/eliminarVideoItem/${idVideo}`;
  return axios.delete(url, { headers });
},

// --- VENTAS: obtener última venta por material (opcional)
async getUltimaVenta(detalleId) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/venta/ultima/${detalleId}`;
  const resp = await axios.get(url, { headers });
  return resp && resp.data ? resp.data : null;
},


async anularDetalleMaterial(token, detalleId, observacion) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };

  const t = encodeURIComponent(String(token || "").trim());
  const id = Number(detalleId || 0);
  const obs = encodeURIComponent(String(observacion || "").trim());

  if (!t || !id || !obs) {
    throw new Error("Parámetros inválidos para anular el detalle.");
  }

  const url = `${base}/api/ecommerce/anularDetalleMaterialesAsync/${t}/${id}/${obs}`;
  console.log("[anularDetalleMaterial] DELETE:", url);

  const resp = await axios.delete(url, { headers });
  return resp && resp.data ? resp.data : {};
},

// --- FOTOS DE CLUSTER (resumen) ---
async getFotosClusterResumen(token, clusterId) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/ArchivoAdjunto/familia/1/item/${clusterId}`;
  const resp = await axios.get(url, { headers });
  const data = resp && resp.data && Array.isArray(resp.data.data) ? resp.data.data : [];
  return data
    .filter(x => Number(x.idTipoArchivo) === 2 || Number(x.IdTipoArchivo) === 2)
    .map(x => ({
      ...x,
      esPortada: Boolean(x.esPortada != null ? x.esPortada : x.EsPortada)
    }));
},

async subirFotosClusterResumen(formData) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const clusterId = Number(formData.get('clusterId'));
  const payload = buildArchivoAdjuntoFormData(formData, {
    idFamilia: 1,
    idItem: clusterId
  });
  const url = `${base}/api/ArchivoAdjunto/crear`;
  console.log("[subirFotosClusterResumen] POST:", url);
  const resp = await axios.post(url, payload, { headers });
  return resp.data;
},

async eliminarFotoClusterResumen(idFoto) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const idUsuarioModificacion = Number(localStorage.getItem('user-id')) || 1;
  const url = `${base}/api/ArchivoAdjunto/eliminar/${idFoto}`;
  console.log("[eliminarFotoClusterResumen] DELETE:", url);
  return axios.delete(url, { headers, params: { idUsuarioModificacion } });
},

// --- VIDEOS DE CLUSTER (resumen) ---
async getVideosClusterResumen(token, clusterId) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/ArchivoAdjunto/familia/1/item/${clusterId}`;
  const resp = await axios.get(url, { headers });
  const data = resp && resp.data && Array.isArray(resp.data.data) ? resp.data.data : [];
  return data
    .filter(x => Number(x.idTipoArchivo) === 3 || Number(x.IdTipoArchivo) === 3)
    .map(x => ({
      ...x,
      esPortada: Boolean(x.esPortada != null ? x.esPortada : x.EsPortada)
    }));
},

async marcarArchivoPrincipal(idArchivo) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const idUsuarioModificacion = Number(localStorage.getItem('user-id')) || 1;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/ArchivoAdjunto/portada/${idArchivo}`;
  const resp = await axios.put(url, null, {
    headers,
    params: { idUsuarioModificacion }
  });
  return resp.data;
},

async agregarVideoClusterResumen(data) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const idUsuarioCreacion = Number(localStorage.getItem('user-id')) || 1;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken(),
    "Content-Type": "application/json"
  };
  const payload = {
    IdFamilia: 1,
    IdTipoArchivo: 3,
    IdItem: Number(data.clusterId),
    Url: data.url,
    Observacion: "",
    IdUsuarioCreacion: idUsuarioCreacion
  };
  const url = `${base}/api/ArchivoAdjunto/crear-url`;
  console.log("[agregarVideoClusterResumen] POST:", url, data);
  const resp = await axios.post(url, payload, { headers });
  return resp.data;
},

async eliminarVideoClusterResumen(idVideo) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const idUsuarioModificacion = Number(localStorage.getItem('user-id')) || 1;
  const url = `${base}/api/ArchivoAdjunto/eliminar/${idVideo}`;
  console.log("[eliminarVideoClusterResumen] DELETE:", url);
  return axios.delete(url, { headers, params: { idUsuarioModificacion } });
},

  // --- CLUSTER (estados custom) ---
  async getEstadosCustom(token) {
    const base = process.env.VUE_APP_API_URL || '';
    const url  = `${base}/api/cluster/estados-custom/${encodeURIComponent(token)}`;
    try {
      const resp = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Accept': 'application/json'
        },
      });
      const data = resp && resp.data ? resp.data : resp;
      // normaliza nombres de propiedades
      return {
        estadoCustom1: (data.estadoCustom1 != null) ? data.estadoCustom1 : data.EstadoCustom1,
        estadoCustom2: (data.estadoCustom2 != null) ? data.estadoCustom2 : data.EstadoCustom2,
        estadoCustom3: (data.estadoCustom3 != null) ? data.estadoCustom3 : data.EstadoCustom3,
      };
    } catch (e) {
      console.error('getEstadosCustom error:', e);
      throw e;
    }
  },

  async removeItemFromCluster(token, idMaterial, idCriterio) {
    const base = process.env.VUE_APP_API_URL || '';
    const url = `${base}/api/cluster/remove-item-from-cluster/${encodeURIComponent(token)}/${idMaterial}/${idCriterio}`;
    const resp = await axios.put(url, null, {
      headers: { 'Authorization': `Bearer ${utilsService.getToken()}` },
    });
    return resp && resp.data ? resp.data : resp;
  },

  // clusterIds/allClusterIds: Id real de dbo.ClustersResumen (no nombreCluster,
  // que se repite entre distintos idCriterio y no identifica una fila de forma única).
  async updateClustersParaEcommerce(token, clusterIds, allClusterIds) {
    const base = process.env.VUE_APP_API_URL || '';
    const url = `${base}/api/cluster/update-clusters-ecommerce`;
    const resp = await axios.post(url, { token, clusterIds, allClusterIds }, {
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    return resp && resp.data ? resp.data : resp;
  },

  // Renombra un cluster Custom 1/2/3 (dbo.ClustersResumen.NombreCustom) por Id real; puede
  // venir más de un Id cuando el resumen agrupado fusionó varias filas bajo el mismo NombreCluster.
  async updateNombreCustomCluster(ids, nombreCustom) {
    const base = process.env.VUE_APP_API_URL || '';
    const url = `${base}/api/cluster/nombre-custom`;
    const resp = await axios.put(url, { ids, nombreCustom }, {
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    return resp && resp.data ? resp.data : resp;
  },

  // Categoria/Fabricante/Modelo editables desde la tabla Resumen Cluster de
  // /lectura-ventas-inventario (dbo.ClustersResumen).
  async updateCamposResumenCluster(id, data) {
    const base = process.env.VUE_APP_API_URL || '';
    const url = `${base}/api/cluster/${encodeURIComponent(id)}/campos-resumen`;
    const resp = await axios.put(url, data, {
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      },
    });
    return resp && resp.data ? resp.data : resp;
  },

  // nro = 1 | 2 | 3 ; nuevoEstado: 'P' | 'C' | 'F'
  async updateEstadoCustom(token, nro, nuevoEstado) {
    const base = process.env.VUE_APP_API_URL || '';
    const t = String(token || '').trim();
    const n = Number(nro || 0);
    const e = String(nuevoEstado || '').trim().toUpperCase();

    if (!t || !n || !e) {
      console.warn('updateEstadoCustom: parámetros inválidos', { token: t, nro: n, nuevoEstado: e });
      throw new Error('Parámetros inválidos');
    }

    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };

    // ✅ Endpoint unificado
    const urlNew = `${base}/api/cluster/update-estado-custom/${encodeURIComponent(n)}`;

    // 👉 Enviamos AMBOS nombres de campo para máxima compatibilidad
    const body = { token: t, estado: e, nuevoEstado: e };

    try {
      const resp = await axios.put(urlNew, body, { headers });
      return (resp && resp.data) ? resp.data : resp;
    } catch (err) {
      // 🔁 Fallback a la ruta legacy, si existe aún
      const status = err && err.response && err.response.status ? err.response.status : 0;
      if (status === 404 || status === 405) {
        const urlLegacy = `${base}/api/cluster/updateEstadoCustom/${encodeURIComponent(n)}/${encodeURIComponent(t)}/${encodeURIComponent(e)}`;
        const r2 = await axios.put(urlLegacy, null, { headers });
        return (r2 && r2.data) ? r2.data : r2;
      }
      console.error('updateEstadoCustom error:', status, err && err.response && err.response.data);
      throw err;
    }
  },

  async updateEstadoCustom1(token, nuevoEstado) { 
    return this.updateEstadoCustom(token, 1, nuevoEstado); 
  },
  async updateEstadoCustom2(token, nuevoEstado) { 
    return this.updateEstadoCustom(token, 2, nuevoEstado); 
  },
  async updateEstadoCustom3(token, nuevoEstado) { 
    return this.updateEstadoCustom(token, 3, nuevoEstado); 
  },

  // --- FINALIZAR CUSTOM usando /api/cluster/update-estado-custom/{nro} ---
  // Finaliza custom N (1|2|3) => setea EstadoCustomN = 'F'
  async finalizarCustom(token, idCriterio) {
    const t = String(token || '').trim();
    const n = Number(idCriterio || 0);
    if (!t || !(n === 1 || n === 2 || n === 3)) {
      throw new Error('Parámetros inválidos para finalizar custom');
    }
    // Reusa la API unificada
    return this.updateEstadoCustom(t, n, 'F');
  },

  // Helpers convenientes (igual interfaz que ya usas en la vista)
  async finalizarCustom1(token) { return this.finalizarCustom(token, 1); },
  async finalizarCustom2(token) { return this.finalizarCustom(token, 2); },
  async finalizarCustom3(token) { return this.finalizarCustom(token, 3); },

  // Alias de compatibilidad: si el front llama updateFinalizaCustom(token, idCriterio), redirige acá
  async updateFinalizaCustom(token, idCriterio) {
    return this.finalizarCustom(token, idCriterio);
  },

// --- MATERIALES (paginado de la empresa) ---
// Llama: /api/materiales/get-material-all/{empresaId}/{idUsuario}/{fecha}/{page}/{pageSize}
async getMaterialAll(empresaId, page = 1, pageSize = 20, filtros = null, lang = 'es') {
  // Usa el apiUrl ya definido arriba: `${process.env.VUE_APP_API_URL}/api/materiales`
  const headers = {
    'Authorization': `Bearer ${utilsService.getToken()}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  // 1) idUsuario: desde filtros o desde la sesión
  let idUsuario = filtros && filtros.idUsuario != null
    ? Number(filtros.idUsuario)
    : null;

  if (!idUsuario) {
    const uinfo = (utilsService.getUserInfo && utilsService.getUserInfo()) || {};
    idUsuario = Number(uinfo.userId || uinfo.idUsuario || uinfo.id || uinfo.UserId || 0);
  }
  if (!idUsuario) {
    throw new Error('No se pudo determinar el usuario logueado (idUsuario).');
  }

  // 2) fecha: usar la que venga; si no, “todo abierto”
  const fecha = (filtros && filtros.fecha)
    ? String(filtros.fecha)
    : '1900-01-01';

  // 3) Construir URL por segmentos (kebab-case exacto)
  const url = `${apiUrl}/get-material-all/${encodeURIComponent(empresaId)}/${encodeURIComponent(idUsuario)}/${encodeURIComponent(fecha)}/${encodeURIComponent(page)}/${encodeURIComponent(pageSize)}`;

  console.log('[materialService] GET:', url);
  const r = await axios.get(url, { headers, params: { lang } });
  return (r && r.data) ? r.data : r;
},

async getMaterialAllTodas(page = 1, pageSize = 20, filtros = null, lang = 'es') {
  return this.getMaterialAll(0, page, pageSize, filtros, lang);
},

  async processFile(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
   
      const response = await axios.post(`${apiUrl}/process-file-materiales`, formData, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error uploading file: ' + error.message);
    }
  },

  async uploadFileMateriales(file, columnas, id_empresa, tipoFlujo = 'FN', tipoInventario = 3, idBodega = null) {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('Columnas', columnas);
    formData.append('id_empresa', id_empresa);
    formData.append('tipoFlujo', tipoFlujo);
    formData.append('tipoInventario', tipoInventario);
    if (idBodega != null) formData.append('idBodega', idBodega);

    try {
      const response = await axios.post(`${apiUrl}/upload-file-materiales`, formData, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  },

  async getLastLogFile(idEmpresa) {
    try {
      const variant = await resolveLastLogEndpoint(idEmpresa);

      if (variant === 'logs') {
        const response = await axios.get(`${apiUrl}/get-last-file-logs`, {
          params: { idEmpresa },
          headers: {
            'Authorization': `Bearer ${utilsService.getToken()}`,
            'Content-Type': 'application/json',
          },
        });
        console.log('Último archivo de registro obtenido:', response.data);
        return response.data;
      }

      if (variant === 'log') {
        const response = await axios.get(`${apiUrl}/get-last-file-log`, {
          params: { idEmpresa },
          headers: {
            'Authorization': `Bearer ${utilsService.getToken()}`,
            'Content-Type': 'application/json',
          },
        });
        console.log('Último archivo de registro obtenido:', response.data);
        return response.data;
      }

      // Si no existe ninguno, no spamear errores
      return null;

    } catch (error) {
      const s = error && error.response && error.response.status ? error.response.status : 0;
      if (s !== 404 && s !== 500) console.debug('getLastLogFile err', s);
      return null;
    }
  },

  async getLastLogFileFull() {
    try {
      console.log('Fetching last file logs full from:',  `${apiUrl}/get-file-logs-full`);
      const response = await axios.get(
        `${apiUrl}/get-file-logs-full`,
        {
          headers: {
            'Authorization': `Bearer ${utilsService.getToken()}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al obtener interes options:', error);
      return null;
    }
  },

  async getClustersResumen(token) {
  try {
    const response = await axios.get(
      `${apiUrlEcommerce}/api/Ecommerce/getClustersResumen/${token}/`,
      {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response && response.data ? response.data : [];
  } catch (error) {
    console.error("[getClustersResumen] error:", error);
    return [];
  }
},

  async getArchivosLogs(idEmpresa) {
    const lang = localStorage.getItem('language') || 'es';
    try {
      const response = await axios.get(
        `${apiUrl}/get-file-logs`,
        {
          params: { idEmpresa, lang },
          headers: {
            'Authorization': `Bearer ${utilsService.getToken()}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const data = response && response.data ? response.data : [];

      // Normalización para tu vista (remover nulls)
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('[getArchivosLogs] error:', error);
      return [];
    }
  },

  async getLogsFiles(idEmpresa) {
    const lang = localStorage.getItem('language') || 'es';
    try {
      const response = await axios.get(`${apiUrl}/get-file-logs?idEmpresa=${idEmpresa}&lang=${lang}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener interes options:', error);
      return [];
    }
  },

  async eliminarCarga(token) {
    const t = String(token || '').trim();
    if (!t) throw new Error('Token vacío');
    const resp = await axios.delete(
      `${apiUrl}/eliminar-carga/${encodeURIComponent(t)}`,
      { headers: { 'Authorization': `Bearer ${utilsService.getToken()}` } }
    );
    return resp && resp.data ? resp.data : true;
  },

  async deleteLogByToken(token) {
    const t = String(token || '').trim();
    if (!t) throw new Error('Token vacío');

    try {
      const resp = await axios.delete(
        `${apiUrl}/delete-file/${encodeURIComponent(t)}`,
        {
          headers: {
            'Authorization': `Bearer ${utilsService.getToken()}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return resp && resp.data ? resp.data : true;
    } catch (e) {
      const status = (e && e.response && e.response.status) ? e.response.status : 0;
      const data   = (e && e.response && e.response.data) ? e.response.data : (e && e.message ? e.message : null);
      console.error('[deleteLogByToken] error:', status, data);
      throw e;
    }
  },

  async getEmpresasAsociadas() {
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/empresas/usuario`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      console.error('Error al obtener empresas asociadas:', error);
      throw error;
    }
  },

  async getPublicadoEcommerce(idEmpresa) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/ecommerce/publicadoEcommerce/${idEmpresa || 0}`,
        { headers: { 'Authorization': `Bearer ${utilsService.getToken()}` } }
      );
      return Array.isArray(response) ? response : (response.data || []);
    } catch (error) {
      console.error('Error al obtener publicado ecommerce:', error);
      throw error;
    }
  },

  // Materiales detras de una ficha Cluster publicada, para el modal de detalle de la
  // columna "Detalle" en /inventario.
  async getDetalleFichaCluster(idFicha) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/ecommerce/publicadoEcommerce/detalleCluster/${idFicha}`,
        { headers: { 'Authorization': `Bearer ${utilsService.getToken()}` } }
      );
      return Array.isArray(response) ? response : (response.data || []);
    } catch (error) {
      console.error('Error al obtener el detalle de la ficha cluster:', error);
      throw error;
    }
  },

  // --- TÉRMINOS Y CONDICIONES POR ÍTEM (ECOMMERCE) ---
async getTerminosCluster(token, detalleId) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };

  const url = `${base}/api/ecommerce/getTerminosCluster/${token}/${detalleId}`;

  const resp = await axios.get(url, { headers });
  return resp.data;
},

async guardarTerminosCluster(data) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken(),
    "Content-Type": "application/json"
  };

  const url = `${base}/api/ecommerce/guardarTerminosCluster`;

  const resp = await axios.post(url, data, { headers });
  return resp.data;
},

  // includeTotal=false evita que el backend cuente el total en cada llamada. Solo
  // sirve cuando ya se conoce (el prefetch por bloques lo obtiene en el primero);
  // por eso el default es true y el resto de los llamadores no cambia.
  async getResultETL(tokenETL, page, pagesize, lang = 'es', includeTotal = true) {
    try {
      const response = await axios.get(`${apiUrl}/get-ETL/${tokenETL}/${page}/${pagesize}`, {
        params: { lang, includeTotal },
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener el ETL:', error);
      return [];
    }
  },

  async getResultETLLite(tokenETL, page, pagesize) {
    try {
      const response = await axios.get(`${apiUrl}/get-ETL-2/${tokenETL}/${page}/${pagesize}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener ETL lite:', error);
      return [];
    }
  },

  async getMaterialesFileETLData(token, page = 1, pageSize = 1000) {
    try {
      const url = `${apiUrl}/get-ETL/${token}/${page}/${pageSize}`;
      console.log('[getMaterialesFileETLData] GET:', url);
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      const rows = response && response.data ? response.data : [];
      console.log(
        '[getMaterialesFileETLData] rows:', rows.length,
        'sample:', rows.slice(0, 3).map(r => ({
          categoria_MM: r.categoria_MM, clase: r.clase
        }))
      );
      return rows;
    } catch (error) {
      const status = (error && error.response && error.response.status) ? error.response.status : 0;
      const data   = (error && error.response && error.response.data)
                      ? error.response.data
                      : (error && error.message ? error.message : null);
      console.error('[getMaterialesFileETLData] error:', status, data);
      return [];
    }
  },

  async getTaxonomias() {
    try {
      const response = await axios.get(`${apiUrl}/taxonomias`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data || [];
    } catch (error) {
      console.error('[getTaxonomias] error:', error);
      return [];
    }
  },

  async getFileLog(tokenETL) {
    const token = String(tokenETL).trim();
    const headers = {
      headers: {
        'Authorization': `Bearer ${utilsService.getToken()}`,
        'Content-Type': 'application/json',
      }
    };

    // 1) materiales
    try {
      const url = `${apiUrl}/get-file/${token}`;
      console.log('[getFileLog] try materiales:', url);
      const response = await axios.get(url, headers);
      console.log('[getFileLog] resp.materiales:', response && response.data);
      return response.data;
    } catch (e1) {
      const s1 = (e1 && e1.response && e1.response.status) ? e1.response.status : 0;
      const d1 = (e1 && e1.response && e1.response.data) ? e1.response.data : null;
      console.debug('[getFileLog] materiales error:', s1, d1);
    }

    // 2) cluster (fallback 1)
    try {
      const base = process.env.VUE_APP_API_URL || '';
      const url1 = `${base}/api/cluster/get-file-log/${token}`;
      console.log('[getFileLog] try cluster/get-file-log:', url1);
      const r2 = await axios.get(url1, headers);
      console.log('[getFileLog] resp.cluster(get-file-log):', r2 && r2.data);
      return r2.data;
    } catch (e2) {
      const s2 = (e2 && e2.response && e2.response.status) ? e2.response.status : 0;
      const d2 = (e2 && e2.response && e2.response.data) ? e2.response.data : null;
      console.debug('[getFileLog] cluster/get-file-log error:', s2, d2);
    }

    // 3) cluster (fallback 2)
    try {
      const base = process.env.VUE_APP_API_URL || '';
      const url2 = `${base}/api/cluster/get-file/${token}`;
      console.log('[getFileLog] try cluster/get-file:', url2);
      const r3 = await axios.get(url2, headers);
      console.log('[getFileLog] resp.cluster(get-file):', r3 && r3.data);
      return r3.data;
    } catch (e3) {
      const s3 = (e3 && e3.response && e3.response.status) ? e3.response.status : 0;
      const d3 = (e3 && e3.response && e3.response.data) ? e3.response.data : null;
      console.debug('[getFileLog] cluster/get-file error:', s3, d3);
    }

    console.warn('[getFileLog] ningún endpoint respondió, devuelvo null');
    return null;
  },

async buscarGlobal(texto) {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };

  const url = `${base}/api/ecommerce/buscarGlobal/${encodeURIComponent(texto)}`;
  console.log("[buscarGlobal] GET:", url);

  const resp = await axios.get(url, { headers });
  return resp.data;
},

async getUltimaSincronizacionPortal() {
  const base = apiUrlEcommerce || process.env.VUE_APP_API_URL;
  const headers = {
    "Authorization": "Bearer " + utilsService.getToken()
  };
  const url = `${base}/api/configuraciones/ultima-sincronizacion-portal`;
  const resp = await axios.get(url, { headers });
  return resp.data;
},
  
  async getFileExport(tokenETL) {
    try {
      const response = await axios.get(`${apiUrl}/maestro-materiales-etl/${tokenETL}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      const disposition = response.headers['content-disposition'];
      let fileName = `maestro_material_procesado_${new Date().toISOString().slice(0, 10)}.xlsx`;
      if (disposition && disposition.includes('filename=')) {
        const fileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, '');
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);

    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el ingreso.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async updateMaterialETL(tokenETL, rowData) {
    try {
      const response = await axios.put(`${apiUrl}/updateETL/${tokenETL}`, rowData, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json'
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating MaterialETL:", error);
      throw error;
    }
  },
  
  async updateEtlBulk(tokenETL, tipo, valor) {
    try {
      const response = await axios.put(`${apiUrl}/update-etl-bulk/${tokenETL}`, { Tipo: tipo, Valor: valor }, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json'
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error en updateEtlBulk:", error);
      throw error;
    }
  },

  async importCategorias(tokenETL, items) {
    try {
      const response = await axios.put(`${apiUrl}/import-categorias/${tokenETL}`, { Items: items }, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json'
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error en importCategorias:", error);
      throw error;
    }
  },

  async getResultadoArchivo(tokenArchivo) {
    try {
      const response = await axios.get(`${apiUrl}/get-result-file?token=${tokenArchivo}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener los datos del archivo:', error);
      return [];
    }
  },

  async updateDefaults(token, data) {
    try {
      const response = await axios.put(`${apiUrl}/update-defaults/${encodeURIComponent(token)}`, data, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al guardar defaults:', error);
      throw error;
    }
  },

  async updateEstadoFlujo(tokenArchivo, nuevoEstado) {
    try {
      const response = await axios.put(`${apiUrl}/update-estado-flujo`, {
        token: tokenArchivo,
        nuevoEstado: nuevoEstado
      }, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json'
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar EstadoFlujo:', error);
      throw error;
    }
  },

  async updatePorcentajeRentEsperado(tokenArchivo, porcentaje) {
    try {
      // CAMBIAR: parámetros en la URL, no en el body
      const response = await axios.put(`${apiUrl}/update-porcentaje-rent-esperado/${tokenArchivo}/${porcentaje}`, 
        {}, // Body vacío
        {
          headers: {
            'Authorization': `Bearer ${utilsService.getToken()}`,
            'Content-Type': 'application/json'
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al actualizar Rentabilidad Esperada:', error);
      throw error;
    }
  },

  async getEstadoFlujoArchivo(tokenArchivo) {
    try {
      const response = await axios.get(`${apiUrl}/get-estado-flujo/${tokenArchivo}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener estado del archivo:', error);
      throw error;
    }
  },

  async getResultETLFull(tokenETL) {
    try {
      const response = await axios.get(`${apiUrl}/get-ETL/${tokenETL}`, {
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener todos los datos ETL:', error);
      return [];
    }
  },

  async getMaestroMateriales(page = 1, pageSize = 50, search = '', sortBy = '') {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Accept': 'application/json',
    };
    const params = { page, pageSize };
    if (search && search.trim()) params.search = search.trim();
    if (sortBy) params.sortBy = sortBy;
    try {
      const resp = await axios.get(`${apiUrl}/maestro-materiales`, { headers, params });
      return (resp && resp.data) ? resp.data : { total: 0, items: [] };
    } catch (error) {
      console.error('[getMaestroMateriales] error:', error);
      return { total: 0, items: [] };
    }
  },

  async updateMaestroMaterial(id, data) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.put(`${apiUrl}/maestro-materiales/${encodeURIComponent(id)}`, data, { headers });
    return resp.data;
  },

  // Actualiza masivamente BrandName o Categoria en dbo.MaestroMateriales: por lista de ids, o por
  // el filtro de busqueda actual (payload.AplicarATodos = true).
  async updateMaestroBulk(payload) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.put(`${apiUrl}/maestro-materiales/update-bulk`, payload, { headers });
    return resp.data;
  },

  // Importación masiva del Pre-Maestro: el Excel se parsea en la pantalla y viaja como JSON.
  // El backend valida de nuevo e inserta con SqlBulkCopy; es todo o nada.
  async importarPreMaestro(items) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.post(`${apiUrl}/pre-maestro-materiales/importar`, { items }, { headers });
    return resp.data;
  },

  // No sube nada: el backend lee dbo.MaterialesFileETL (cargas activas, sin marca de proceso) y
  // deja en el Pre-Maestro los materiales que faltan catalogar, con su SkuInexlink asignado.
  // Con simular:true devuelve el mismo diagnostico sin escribir.
  async procesarPreMaestroEtl({ tokens = null, simular = false } = {}) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.post(`${apiUrl}/pre-maestro-materiales/procesar-etl`, { tokens, simular }, { headers });
    return resp.data;
  },

  // Cuanto hay por procesar, para no disparar el proceso a ciegas.
  async getPendientesPreMaestroEtl() {
    const headers = { 'Authorization': `Bearer ${utilsService.getToken()}` };
    const resp = await axios.get(`${apiUrl}/pre-maestro-materiales/pendientes-etl`, { headers });
    return resp.data;
  },

  // Borrado fisico: la fila desaparece de dbo.PreMaestroMateriales.
  async deletePreMaestroMaterial(id) {
    const headers = { 'Authorization': `Bearer ${utilsService.getToken()}` };
    const resp = await axios.delete(`${apiUrl}/pre-maestro-materiales/${id}`, { headers });
    return resp.data;
  },

  async createPreMaestroMaterial(data) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.post(`${apiUrl}/pre-maestro-materiales`, data, { headers });
    return resp.data;
  },

  async updatePreMaestroMaterial(id, data) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.put(`${apiUrl}/pre-maestro-materiales/${encodeURIComponent(id)}`, data, { headers });
    return resp.data;
  },

  // Actualiza masivamente BrandName o CategoriaInexlink: por lista de ids, o por el filtro de
  // busqueda actual sobre los pendientes (payload.AplicarATodos = true).
  async updatePreMaestroBulk(payload) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.put(`${apiUrl}/pre-maestro-materiales/update-bulk`, payload, { headers });
    return resp.data;
  },

  // Integra TODOS los pendientes, no solo los de la pagina. Respeta el texto de busqueda de la
  // grilla, asi lo que se integra es lo que el usuario esta viendo.
  async integrarTodoPreMaestroAMM(search = null) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.post(`${apiUrl}/pre-maestro-materiales/integrar-mm-todos`, { search }, { headers });
    return resp.data;
  },

  async integrarPreMaestroMaterialesAMM(ids) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.post(`${apiUrl}/pre-maestro-materiales/integrar-mm`, { ids }, { headers });
    return resp.data;
  },

  async getPreMaestroMateriales(page = 1, pageSize = 50, search = '', estado = 'pendientes') {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Accept': 'application/json',
    };
    const params = { page, pageSize, estado };
    if (search && search.trim()) params.search = search.trim();
    try {
      const resp = await axios.get(`${apiUrl}/pre-maestro-materiales`, { headers, params });
      return (resp && resp.data) ? resp.data : { total: 0, items: [] };
    } catch (error) {
      console.error('[getPreMaestroMateriales] error:', error);
      return { total: 0, items: [] };
    }
  },

  // Listado transversal de archivos cargados (todas las empresas) para la pantalla
  // de estado de procesos. El endpoint está restringido a admin y visita.
  // soloActivos: por defecto la pantalla muestra unicamente las cargas vigentes.
  async getArchivosCargados(soloActivos = true) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Accept': 'application/json',
    };
    const resp = await axios.get(`${apiUrl}/archivos-cargados`, { headers, params: { soloActivos } });
    return Array.isArray(resp && resp.data) ? resp.data : [];
  },

  // Revisión de traducciones automáticas (translate_detalles.py) de PartName/Detalles.
  async getTraduccionesParaRevision(page = 1, pageSize = 50, search = '', soloCorregidas = false, idEmpresa = null, token = null) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Accept': 'application/json',
    };
    const params = { page, pageSize, soloCorregidas };
    if (search && search.trim()) params.search = search.trim();
    if (idEmpresa) params.idEmpresa = idEmpresa;
    if (token) params.token = token;
    try {
      const resp = await axios.get(`${apiUrlTraduccion}/revision`, { headers, params });
      return (resp && resp.data) ? resp.data : { total: 0, items: [] };
    } catch (error) {
      console.error('[getTraduccionesParaRevision] error:', error);
      return { total: 0, items: [] };
    }
  },

  async updateTraduccionRevision(id, data) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.put(`${apiUrlTraduccion}/revision/${encodeURIComponent(id)}`, data, { headers });
    return resp.data;
  },

  // Glosario de traducción: marcas protegidas (Tipo='Proteger') y jerga técnica con
  // traducción ya conocida (Tipo='Reemplazar'), que translate_detalles.py usa para no
  // repetir los mismos errores (ver dbo.GlosarioTraduccion).
  async getGlosario(soloActivos = false) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Accept': 'application/json',
    };
    try {
      const resp = await axios.get(`${apiUrlTraduccion}/glosario`, { headers, params: { soloActivos } });
      return (resp && resp.data && Array.isArray(resp.data.items)) ? resp.data.items : [];
    } catch (error) {
      console.error('[getGlosario] error:', error);
      return [];
    }
  },

  async crearGlosario(data) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.post(`${apiUrlTraduccion}/glosario`, data, { headers });
    return resp.data;
  },

  async actualizarGlosario(id, data) {
    const headers = {
      'Authorization': `Bearer ${utilsService.getToken()}`,
      'Content-Type': 'application/json',
    };
    const resp = await axios.put(`${apiUrlTraduccion}/glosario/${encodeURIComponent(id)}`, data, { headers });
    return resp.data;
  },

  // Borrado físico (no soft-delete): saca el término de dbo.GlosarioTraduccion.
  async eliminarGlosario(id) {
    const headers = { 'Authorization': `Bearer ${utilsService.getToken()}` };
    const resp = await axios.delete(`${apiUrlTraduccion}/glosario/${encodeURIComponent(id)}`, { headers });
    return resp.data;
  },
};

export default materialService;
</script>
